<template>
  <v-card
    dark
    class="overflow-y-scroll overflow-x-hidden background--color-c"
    style="display: flex; flex-flow: column; width: 100%; height: 100%"
  >
    <v-card style="border-radius: 0px;" light flat>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Sök"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    </v-card>
    <v-simple-table style="border-radius: 0;" dense light>
      <thead>
        <tr>
          <th
            style="padding: 0; width:  40px; max-width:  40px; min-width:  40px;"
          ></th>
          <th
            style="padding: 0; width: 100px; max-width: 100px; min-width: 100px;"
            class="text-left"
          >
            Röstsedlar
          </th>
          <th
            style="padding: 0; width:  50px; max-width:  50px; min-width:  50px;"
            v-if="weighted"
            class="text-left"
          >
            Andelar
          </th>
          <th
            style="padding: 0; width: 130px; max-width: 130px; min-width: 130px;"
            class="text-left"
          >
            Personnummer
          </th>
          <th
            style="padding: 0; width:  40px; max-width:  40px; min-width:  40px;"
          ></th>
          <th
            style="padding: 0; width:  56px; max-width:  56px; min-width:  56px;"
          ></th>
          <th
            style="padding: 0; width:  10px; max-width:  10px; min-width:  10px;"
          ></th>
        </tr>
      </thead>
    </v-simple-table>
    <div
      class="overflow-x-hidden"
      style="height: 100%;border-radius: 0; "
      @click="closeEdit"
    >
      <v-simple-table
        light
        dense
        height="100%"
        style="overflow-x:hidden ;border-radius: 0;height: 100%;"
      >
        <tbody>
          <tr
            v-for="ballot in displayItems"
            :key="ballot.id"
            style="cursor: pointer;"
          >
            <td
              style="padding-left: 8px; width:  40px; max-width:  40px; min-width:  40px;"
            >
              <v-icon v-if="ballot.present" color="green"
                >mdi-checkbox-marked-circle-outline
              </v-icon>
              <v-icon
                v-else
                v-on:click.stop.prevent="manualRegistration(ballot)"
                >mdi-checkbox-blank-circle-outline</v-icon
              >
            </td>
            <td
              style="padding: 0; width: 100px; max-width: 100px; min-width: 100px;"
            >
              {{ ballot.ballots.join(", ") }}
            </td>
            <td
              style="padding: 0; width:  50px; max-width:  50px; min-width:  50px;"
              v-if="weighted"
            >
              {{ ballot.shares.join(", ") }}
            </td>
            <td
              style="padding: 0; width: 130px; max-width: 130px; min-width: 130px;"
            >
              {{ obfuscateSsn(ballot.ssn)
              }}<span class="obfuscated-text">{{
                lastNumbers(ballot.ssn)
              }}</span>
              <span v-if="ballot.delegatedTo">
                (*{{ obfuscateSsn(ballot.delegatedTo)
                }}<span class="obfuscated-text">{{
                  lastNumbers(ballot.delegatedTo)
                }}</span
                >)</span
              >
            </td>
            <td
              style="padding: 0; width:  40px; max-width:  40px; min-width:  40px;"
            >
              <v-icon v-on:click.stop.prevent="editMandate(ballot)"
                >mdi-file-document-edit-outline
              </v-icon>
            </td>
            <td
              style="padding: 0; width:  52px; max-width:  52px; min-width:  52px;"
            >
              <v-icon v-on:click.stop.prevent="deleteBallot(ballot)"
                >mdi-delete
              </v-icon>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <v-card flat light style="border-radius: 0;">
      <v-btn text icon @click="decPage">
        <v-icon>mdi-arrow-left-bold-circle-outline</v-icon>
      </v-btn>
      <span>Sida {{ activePage + 1 }} / {{ pageCount }}</span>
      <v-btn text icon @click="incPage">
        <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
      </v-btn>
    </v-card>
    <div v-if="edit" style="background: rgba(0, 0, 0, 0.25)">
      <v-row no-gutters>
        <v-col class="col-5">
          <v-text-field
            label="Personnummer"
            v-model="form.ssn"
            color="primary"
            light
            solo
            flat
            single-line
            dense
            disabled
            style="margin: 10px 0 0 10px;"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Ge fullmakt till"
            v-model="form.delegatedTo"
            color="primary"
            light
            solo
            flat
            single-line
            dense
            clearable
            style="margin: 10px 0 0 10px;"
          ></v-text-field>
        </v-col>
        <v-col style="flex-grow: 0; flex-shrink: 0; padding: 13px 8px">
          <v-btn
            fab
            x-small
            color="white"
            class="color-a"
            :disabled="!isValidEditInput"
            @click="saveMandate"
            dark
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row no-gutters>
        <v-col class="col-4">
          <v-text-field
            v-model="form.ballot"
            label="Röstsedel"
            style="margin-left:10px;"
          ></v-text-field>
        </v-col>
        <v-col v-if="weighted">
          <v-text-field
            v-model="form.shares"
            :disabled="edit"
            label="Andelar"
            hint=""
            style="margin-left:10px;"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            v-model="form.ssn"
            :disabled="edit"
            label="Personnummer"
            hint="YYYYMMDDXXXX (12 siffror)"
            style="margin-left:10px;"
          ></v-text-field>
        </v-col>
        <v-col style="flex-grow: 0; flex-shrink: 0; padding: 13px 8px">
          <v-btn
            fab
            x-small
            color="white"
            class="color-a"
            dark
            @click="addBallot"
            :disabled="!isValidInput"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-model="manualRegistrationDialog"
      max-width="600"
      persistent
      style="background:#fff;"
    >
      <v-card style="padding: 40px">
        <v-card-title
          >Manuell närvaroregistrering för
          {{ obfuscateSsn(manualRegistrationData.ssn)
          }}<span class="obfuscated-text">{{
            lastNumbers(manualRegistrationData.ssn)
          }}</span></v-card-title
        >
        <v-text-field label="Namn" v-model="manualRegistrationData.name" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="manualRegistrationDialog = false">Avbryt</v-btn>
          <v-btn text color="primary" type="submit" @click="manuallyRegister"
            >Registrera närvarande
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { isSSN } from "@/assets/lib/isSSN.js";

function cleanBallot(ballotId) {
  return ballotId.replace(/[./]/g, "").replace(/__/g, "");
}

const form = {
  ssn: "",
  ballot: "",
  shares: 1,
  delegatedTo: ""
};

export default {
  props: {
    meeting: Object,
    ballotsAndMandates: Array,
    weighted: Boolean,
    state: Number
  },
  data() {
    return {
      page: 0,
      pageSize: 100,
      search: "",
      edit: false,
      form: { ...form },
      manualRegistrationDialog: false,
      manualRegistrationData: { ssn: "", name: "" }
    };
  },
  computed: {
    isValidInput() {
      var validBallot = !!this.form.ballot;
      return isSSN(this.form.ssn) && validBallot;
    },
    isValidEditInput() {
      return (
        isSSN(this.form.ssn) &&
        (!this.form.delegatedTo || isSSN(this.form.delegatedTo))
      );
    },
    present() {
      let present = 0;
      this.ballotsAndMandates.forEach(elector => {
        if (elector.present === true) {
          present += 1;
        }
      });
      const total = this.ballotsAndMandates.length;

      return present.toString() + "/" + total.toString();
    },
    pageCount() {
      return Math.ceil(this.filteredItems.length / this.pageSize);
    },
    activePage() {
      if (this.page > this.pageCount) {
        return this.pageCount - 1;
      } else {
        return this.page;
      }
    },
    filteredItems() {
      const searchTerm = this.search.toLowerCase();
      return this.ballotsAndMandates.filter(
        item =>
          item.ssn.includes(searchTerm) ||
          (item.delegatedTo && item.delegatedTo.includes(searchTerm)) ||
          item.ballots
            .join(" ")
            .toLowerCase()
            .includes(searchTerm)
      );
    },
    displayItems() {
      return this.filteredItems.slice(
        this.activePage * this.pageSize,
        this.activePage * this.pageSize + this.pageSize
      );
    }
  },
  methods: {
    lastNumbers(ssn) {
      return ssn.replace(/^\d\d\d\d\d\d\d\d/, "");
    },
    obfuscateSsn(ssn) {
      return ssn.replace(/\d\d\d\d$/, "");
    },
    decPage() {
      this.page--;
      if (this.page < 0) {
        this.page = 0;
      }
    },
    incPage() {
      this.page++;
      if (this.page > this.pageCount - 1) {
        this.page = this.pageCount - 1;
      }
    },
    editMandate(ballot) {
      this.form = {
        ssn: ballot.ssn,
        ballot: this.form.ballot,
        shares: this.form.shares,
        delegatedTo: ballot.delegatedTo
      };
      this.edit = true;
    },
    async manualRegistration(ballot) {
      if (this.state !== 2) {
        return;
      }
      this.manualRegistrationData.ssn = ballot.ssn;
      if (ballot.delegatedTo) {
        this.manualRegistrationData.ssn = ballot.delegatedTo;
      }
      this.manualDisplaySsn = this.manualRegistrationData.ssn;
      // this.manualDisplaySsn = ballot.ssn;
      // if (ballot.delegatedTo) {
      //   this.manualRegistrationData.delegatedTo = ballot.delegatedTo;
      //   this.manualDisplaySsn = ballot.delegatedTo;
      // }
      this.manualRegistrationData.name = "";
      this.manualRegistrationDialog = true;
    },
    async manuallyRegister() {
      if (this.manualRegistrationData.name !== "") {
        await this.$store.dispatch("meetings/manuallyRegister", {
          meeting: this.meeting,
          mandate: {
            ...this.manualRegistrationData,
            admin: this.$store.getters["auth/auth"].uid
          }
        });
      }
      this.manualRegistrationData = { name: "", ssn: "" };
      this.manualRegistrationDialog = false;
    },
    async saveMandate() {
      if (this.form.ssn === this.form.delegatedTo || !this.form.delegatedTo) {
        await this.deleteMandate(this.form);
      } else {
        await this.addMandate(this.form);
      }
    },
    addBallot() {
      if (!isSSN(this.form.ssn)) return;
      if (
        Object.keys(this.meeting.ballots).length < 5 ||
        this.meeting.contractId ||
        this.meeting.stripePaymentMethod
      ) {
        const success = this.$store.dispatch("meetings/addBallot", {
          meeting: this.meeting,
          ballot: {
            ballot: cleanBallot(this.form.ballot),
            ssn: this.form.ssn,
            shares: Number(this.form.shares)
          }
        });
        if (success) {
          this.form = { ...form };
        }
        this.edit = false;
      } else {
        this.$store.commit("snackbar/push", {
          text: "Lägg till betalningsmetod",
          icon: "mdi-credit-card-check-outline",
          accept: () => {
            this.$root.$emit("missingPaymentMetod");
          },
          deny: () => {}
        });
      }
    },
    async addMandate(ballot) {
      if (!isSSN(ballot.ssn)) return;
      // TODO: Add Check for delegatedTo SSN
      const success = await this.$store.dispatch("meetings/addMandate", {
        meeting: this.meeting,
        mandate: {
          id: ballot.ssn,
          ssn: ballot.delegatedTo
        }
      });

      if (success) {
        this.form = { ...form };
        this.edit = false;
      }
    },
    async deleteMandate(ballot) {
      const success = await this.$store.dispatch("meetings/deleteMandate", {
        meeting: this.meeting,
        mandate: {
          id: ballot.ssn
        }
      });

      if (success) {
        this.form = { ...form };
        this.edit = false;
      }
    },
    async deleteBallot(ballot) {
      var success = false;

      this.$store.dispatch("meetings/deleteMandate", {
        meeting: this.meeting,
        mandate: {
          id: ballot.ssn
        }
      });

      ballot.ballots.forEach(ballotIdToDelete => {
        success = this.$store.dispatch("meetings/deleteBallot", {
          meeting: this.meeting,
          ballot: {
            ballot: ballotIdToDelete,
            ssn: ballot.ssn
          }
        });
      });

      if (success) {
        this.form = { ...form };
      }

      this.edit = false;
    },
    closeEdit() {
      this.edit = false;
      this.form = { ...form };
    }
  }
};
</script>

<style>
.obfuscated-text {
  color: transparent;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.obfuscated-text:hover {
  color: rgba(0, 0, 0, 0.87);
  text-shadow: 0 0 0 rgba(0, 0, 0, 0);
}
</style>
